<template>
  <b-card>
    <implantacao-list
      :colunas="colunasListagem"
      :carregar="carregar"
      :filtros="filtrosPrincipais"
      :novo="novo"
      filtrar-por-ativo
      :mostrar-remover-lote="false"
    />
  </b-card>
</template>

<style>

</style>

<script>

import api from '@/app-modulo/comuns/implantacoes/shared/services/api'

export default {
  name: 'Implantacoes',
  components: {
    ImplantacaoList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
  },
  data() {
    return {
      colunasListagem: [
        { label: 'Nome', field: 'name' },
        { label: 'Identificador', field: 'identifier' },
      ],
      filtrosPrincipais: [{ colunas: ['name', 'identifier'], valor: null }],
    }
  },
  methods: {
    carregar(page, pageSize, filtro) {
      const filtros = {
        filtroPrincipal: filtro,
        filtrosAdicionais: this.filtrosPrincipais,
      }
      return api.listar(page, pageSize, filtros)
    },
    novo() {
      this.$router.push({ name: 'novo-cliente-saas' })
    },
  },
}

</script>
